import { connect } from "react-redux";
import React, { useMemo, useState } from "react";
import { CAlert, CButton, CCol, CForm, CInputGroup, CInputGroupText, CRow } from "@coreui/react";

import * as saleMethod from "../../../../api/method/saleMethod";
import StoreListWhere from "../../where/StoreListWhere";

import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import { Loading } from "../../../../components/common";
import { AgGridReact } from "ag-grid-react";
import numeral from "numeral";

import 'devextreme/dist/css/dx.light.css';
import { Column, DataGrid, GroupItem, SearchPanel, Summary, TotalItem } from "devextreme-react/data-grid";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";

const DevSales = (props) => {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

  const [currentSaleStatData, setCurrentSaleStatData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    visible: false,
    message: ""
  });
  const [searchForm, setSearchForm] = useState({
    saleDt: dayjs()
  });

  const currencyFormatter = (params) => {
    return numeral(params.value).format('0,0');
  };

  const [columnDefs] = useState([
    { field: "posCd", headerName: "포스번호", width: 60, wrapHeaderText: true },
    { field: "billNo", headerName: "영수증번호", width: 80, wrapHeaderText: true },
    { field: "", headerName: "E-휴게소\n영수증번호", width: 100, wrapHeaderText: true },
    { field: "saleTime", headerName: "결제시각" },
    { field: "tradeTypeNm", headerName: "구분" },
    { field: "saleAmt", headerName: "총매출액", valueFormatter: currencyFormatter },
    { field: "vaultAmt", headerName: "실매출액", valueFormatter: currencyFormatter },
    { field: "netAmt", headerName: "가액", valueFormatter: currencyFormatter },
    { field: "payAmtVat", headerName: "부가세", valueFormatter: currencyFormatter },
    { headerName: "결제수단", children: [
        { field: "cashAmt", headerName: "결제합계", valueFormatter: currencyFormatter},
        { field: "cashAmt", headerName: "현금영수", valueFormatter: currencyFormatter},
        { field: "cardAmt", headerName: "신용카드", valueFormatter: currencyFormatter},
      ] },
  ]);

  const search = () => {
    const { cmpCd, brandCd, storeCd } = props.selected;
    if (brandCd.length === 0) {
      setError({
        visible: true,
        message: "조회시 휴게소는 반드시 선택하셔야 합니다."
      });
      return;
    }

    if (storeCd.length === 0) {
      setError({
        visible: true,
        message: "조회시 매장은 반드시 선택하셔야 합니다."
      });
      return;
    }

    const params = {
      cmpCd: cmpCd,
      brandCd: brandCd,
      storeCd: storeCd,
      saleDt: searchForm.saleDt.format("YYYYMMDD")
    };

    setLoading(true);
    saleMethod.getCurrentDay(params).then((result) => {
      console.log(result);
      setLoading(false);
      setCurrentSaleStatData(result);
    });
  };

  const handleSelect = (code, value) => {
    if (value === "C") {
      setSearchForm((state) => ({
        ...state,
        cmpCd: code
      }));
    } else if (value === "B") {
      setSearchForm((state) => ({
        ...state,
        brandCd: code
      }));
    } else if (value === "S") {
      setSearchForm((state) => ({
        ...state,
        storeCd: code
      }));
    } else if (value === "O") {
      setSearchForm((state) => ({
        ...state,
        cornerCd: code
      }));
    }
  };

  return (
    <>
      <div style={containerStyle}>
        {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
        <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
          <h5>당일-매출상세</h5>
          <CButton color="dark" onClick={search}>조회</CButton>
        </div>
        <CForm>
          <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
          <CCol sm={5}>
            <CInputGroup>
              <CInputGroupText style={{ width: 100 }}>조회일자</CInputGroupText>
              <CInputGroupText style={{ background: "white", height: 38 }}>
                <DatePicker bordered={false}
                            separator={"~"}
                            placeholder={""}
                            locale={locale}
                            value={searchForm.saleDt}
                            onChange={(dayjs, dateString) => {
                              setSearchForm((state) => ({
                                ...state, saleDt: dayjs
                              }));
                            }}/>
              </CInputGroupText>
            </CInputGroup>
          </CCol>
          <CRow>
            <div style={{ width: "100%", height: 550, marginTop: 10 }}>
              {loading ? <Loading/> : null}
              <DataGrid id={"dataGrid"}
                        showBorders={true}
                        columnAutoWidth={true}
                        allowColumnReordering={true}
                        dataSource={currentSaleStatData}>
                <Column dataField={"posCd"} caption={"포스번호"} />
                <Column dataField={"billNo"} caption={"영수증번호"} />
                <Column dataField={"saleTime"} caption={"결제시각"} format={(data) => { format: dayjs(data, "YYYYMMDDHHmmss").format("HH:mm:ss")}} />
                <Column dataField={"tradeTypeNm"} caption={"구분"} />
                <Column dataField={"saleAmt"} caption={"총매출액"} format={{ currency: 'KOR' }} />
                <Column dataField={"vaultAmt"} caption={"실매출액"} format={{ currency: 'KOR' }} />
                <Column dataField={"netAmt"} caption={"가액"} format={{ currency: 'KOR' }} />
                <Column dataField={"payAmtVat"} caption={"부가세"} format={{ currency: 'KOR' }} />
                <Summary>
                  <TotalItem summaryType={"sum"}
                             column={"saleAmt"}
                             displayFormat={"합계 : {0}"}
                  />
                </Summary>
              </DataGrid>
            </div>
          </CRow>
        </CForm>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { account, store, selected } = state;
  return {
    account, store, selected
  };
};

export default connect(mapStateToProps, null)(DevSales);
